/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontFeaturedSection_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"StorefrontProductGrid_viewer">;
    readonly " $refType": "StorefrontFeaturedSection_viewer";
};
export type StorefrontFeaturedSection_viewer$data = StorefrontFeaturedSection_viewer;
export type StorefrontFeaturedSection_viewer$key = {
    readonly " $data"?: StorefrontFeaturedSection_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontFeaturedSection_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontFeaturedSection_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontProductGrid_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'd7f364a176f42757299c334987f84e09';
export default node;
